const getIsVerified = () => {
  const tenMinutes = 10 * 60 * 1000
  const lastOTP = JSON.parse(localStorage.getItem('lastOTP'))
  const isVerified =
    lastOTP !== null ? lastOTP + tenMinutes > new Date().getTime() : false
  return isVerified
}
export default getIsVerified
